#import "@/v1-console/map/auth/map.auth.fragment.gql"
#import "@/v1-console/currentUser/currentUser.fragment.gql"

query AppContextQuery($layerTokensInput: ServiceTokensInput!) {
  getServiceTokens(input: $layerTokensInput) {
    ...MapAuthServiceTokenFragment
  }
  getCurrentUser {
    ...CurrentUserFragment
  }
}
